import React from 'react';

const Footer = () => {
    return (
        <>
            <h6 className="bg-dark text-white text-center fixed-bottom mb-0">This app developed by Praveen with <img src="logo192.png" alt="" className="developerIcon" /> </h6>

        </>
    );
}

export default Footer;